var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket-detail-route" },
    [
      _vm.isReady
        ? [
            _vm.isNewTicket
              ? _c("div", { staticClass: "new-request-page show-scrollbar" }, [
                  _c("header", { staticClass: "new-request-header" }, [
                    _c(
                      "button",
                      {
                        staticClass: "request-back",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.returnToList()
                          }
                        }
                      },
                      [
                        _c("portal-icon", {
                          attrs: { name: "arrow-left", size: 16 }
                        }),
                        _vm._v(
                          " " + _vm._s(_vm.$t("requests.page-heading")) + " "
                        )
                      ],
                      1
                    ),
                    _c("h1", [_vm._v(_vm._s(_vm.pageHeader))])
                  ]),
                  _c(
                    "section",
                    { staticClass: "new-request-shell" },
                    [
                      _c("new-ticket", {
                        attrs: { "ticket-types": _vm.ticketTypes },
                        on: {
                          cancel: function($event) {
                            return _vm.returnToList()
                          },
                          "new-ticket": function($event) {
                            return _vm.newTicket($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              : _c("existing-ticket", {
                  attrs: { id: _vm.id, "ticket-types": _vm.ticketTypes },
                  on: {
                    back: function($event) {
                      return _vm.returnToList()
                    },
                    cancel: function($event) {
                      return _vm.returnToList()
                    }
                  }
                })
          ]
        : _c(
            "div",
            { staticClass: "ticket-detail-loading" },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  size: 36,
                  width: 3,
                  color: "primary"
                }
              })
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }